module.exports = __webpack_public_path__ + "img/flange_position_marking.c7162a74.webp";